<template>
    <div class="teamQualified">
        <div style="float:left">
        <s-button @onclick="" :label="parseInt(numero)+1" theme="is-success is-small" />
        </div>
        <span label="pseudo">Anonyme</span>
    </div>
</template>
<style scoped>
    .teamQualified {
        height: 100px;
        width: 130px;
        margin-left: 10px;
        margin-bottom: 5px;
        background-color: rgb(224, 245, 194);
        border-radius: 20px;
    }
    .pseudo {
        font-size: 12px;
        padding-left: 10px;
    }
</style>
<script>
export default {
    props: ["numero","joueurs"]
}
</script>